import { useLang, CATEGORIES, catLabel } from "@/lib/i18n";

export const CategoryFilter = ({ events, value, onChange }) => {
  const { t } = useLang();
  const present = [...new Set((events || []).map((e) => e.category || "other"))];
  const cats = [
    ...CATEGORIES.filter((c) => present.includes(c)),
    ...present.filter((c) => !CATEGORIES.includes(c)).sort(),
  ];
  if (cats.length < 2) return null;
  const chip = (active) =>
    `px-3 py-1 rounded-full border text-xs transition-colors active:scale-95 ${
      active ? "bg-foreground text-background border-foreground font-medium" : "border-border text-muted-foreground hover:text-foreground"
    }`;
  return (
    <div className="flex flex-wrap gap-2" data-testid="category-filter">
      <button data-testid="category-chip-all" className={chip(value === "all")} onClick={() => onChange("all")}>
        {t("all_categories")}
      </button>
      {cats.map((c) => (
        <button key={c} data-testid={`category-chip-${c}`} className={chip(value === c)} onClick={() => onChange(c)}>
          {catLabel(t, c)}
        </button>
      ))}
    </div>
  );
};
